module.exports = __webpack_public_path__ + "static/img/qiepian1.8166586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian1.png
// module id = zYkj
// module chunks = 2